import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ControlledFormInput } from '../../../../Lib/Utils/FormUtils/ControlledFormInput';
import { AddTagFormData } from '../types';

export function CommentsSection() {
  const { control } = useFormContext<AddTagFormData>();

  return (
    <div className="rounded-xl border border-neutral-200 shadow-sm p-5">
      <ControlledFormInput
        name="comments"
        label="Comments"
        control={control}
        inputType="textarea"
        inputProps={{
          className: 'w-full',
          placeholder: 'Tell us any additional details about the sample.',
          rows: 4,
        }}
      />
    </div>
  );
}
